// extracted by mini-css-extract-plugin
module.exports = {"priceInput":"xe7b-ydZxpMwAegQrYD4h"};